import { createItemsData } from '../utils/request.utils'
import { Service } from './base-service'
import { HALApiService } from './hal-api.service'

export const drService = new Service('/delivery-services/requests', HALApiService, createItemsData)
